import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconStatusDotStyle0 = gravityIconIndividualCss;

const GravityIconStatusDot = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '5390bef81796178c819ff0a17535c3b3cb7a272b', color: this.color, size: this.size }, h("svg", { key: '59dbe3db274ce9d7a52336d9b9f57cdf0143391a', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '1d8227f85b0ed9e17a88a3af6ef9aceb27459b86', d: "M7 11a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z", fill: "currentColor", "fill-opacity": ".9" }))));
    }
};
GravityIconStatusDot.style = GravityIconStatusDotStyle0;

export { GravityIconStatusDot as gravity_icon_status_dot };

//# sourceMappingURL=gravity-icon-status-dot.entry.js.map